import  { useState, useEffect, createContext, useContext } from "react";
import apisService from "api/services/apiService";
import { currentRegion } from "data/Atoms";
import { useSetRecoilState } from "recoil";

const OffersContext = createContext();

export const OffersContextProvider = ({ children }) => {
  const [map, setMap] = useState();
  const [regionsData, setRegionsData] = useState(undefined);
  const [regionsDataLoading, setRegionsDataLoading] = useState(false);
  const [offersData, setOffersData] = useState({});
  const [neighborhoodData, setNeighborhoodData] = useState({});
  const setCurrentRegion = useSetRecoilState(currentRegion);

  const getRegionsData = () => {
    setRegionsDataLoading(true);
    apisService.offer
      .getRegions()
      .then(({ data: { data } }) => {
        setRegionsData(data);
        setCurrentRegion(data[0]);
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setRegionsDataLoading(false);
      });
  };

  useEffect(() => {
    getRegionsData();
  }, []);

  return (
    <OffersContext.Provider
      value={{
        map,
        setMap,
        offersData,
        setOffersData,
        neighborhoodData,
        setNeighborhoodData,
        regionsData,
        regionsDataLoading,
      }}
    >
      {children}
    </OffersContext.Provider>
  );
};

export const useOffersContext = () => {
  return useContext(OffersContext);
};
